import $ from "jquery";
import * as Common from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import { WindowUtils } from "msal";

export default function standart() {}

export const fillDetail = () => {
  $("#d-algemeen-gisratio").html(
    window.$mm_work_order_selectedRow.algemeenGisratio
  );
  $("#d-status").html(window.$mm_work_order_selectedRow.status);
  $("#d-maatregel-naam").html(window.$mm_work_order_selectedRow.maatregelNaam);
  $("#d-beheereenheid-naam").html(
    window.$mm_work_order_selectedRow.beheereenheidNaam
  );
  $("#d-beheeractiviteit-laag").html(
    window.$mm_work_order_selectedRow.beheeractiviteitLaag
  );
  $("#d-discipline-naam").html(
    window.$mm_work_order_selectedRow.disciplineNaam
  );
  $("#d-status-tijdstip_verzonden").html(
    window.$mm_work_order_selectedRow.statusTijdstipVerzonden
  );
};

export function GetColumnProperties(callType) {}
export function GetColumnPropertiesForModel(
  model,
  pageNr,
  pageSize,
  callType,
  itemId,
  token
) {}



export async function DefinationStatus() {
  var model = {
    definitions: ["b2cd4bcd-0840-4953-85bb-b42ef9fbee78"],
    query: {
      definitions: ["b2cd4bcd-0840-4953-85bb-b42ef9fbee78"],
    },
  };
  let result = await omnimap.GetDefinationStatusAction(
    model,
    window.$mm_management_units_token
  );

  if (result.data !== undefined) {
    result.data.forEach((element) => {
      window.$mm_work_order_plannigStatus.push(element.status);
    });
  }
}
